import axios from "@/lib/axios"
import type { TokenValues } from "@/lib/custom-theme"

export interface CustomThemeRecord {
    id: number
    name: string
    slug: string
    description?: string | null
    light: TokenValues
    dark: TokenValues
    is_published: boolean
    created_by_id?: number | null
    created_at?: string
    updated_at?: string | null
}

export interface ThemeUsageRow {
    theme: string
    label: string
    is_custom: boolean
    users: number
    percentage: number
}

export interface ThemeUsageStats {
    breakdown: ThemeUsageRow[]
    total_reported: number
    not_reported: number
    custom_theme_count: number
}

export interface ThemeWritePayload {
    name?: string
    description?: string | null
    light?: TokenValues
    dark?: TokenValues
    is_published?: boolean
}

export const themeService = {
    list: async (): Promise<CustomThemeRecord[]> => {
        const res = await axios.get("/themes/")
        return res.data.themes
    },

    create: async (payload: ThemeWritePayload): Promise<CustomThemeRecord> => {
        const res = await axios.post("/themes/", payload)
        return res.data.theme
    },

    update: async (id: number, payload: ThemeWritePayload): Promise<CustomThemeRecord> => {
        const res = await axios.put(`/themes/${id}`, payload)
        return res.data.theme
    },

    remove: async (id: number): Promise<void> => {
        await axios.delete(`/themes/${id}`)
    },

    /** Fire-and-forget: records which theme this user is on. */
    reportUsage: async (theme: string): Promise<void> => {
        await axios.post("/themes/usage", { theme })
    },

    usageStats: async (): Promise<ThemeUsageStats> => {
        const res = await axios.get("/themes/usage/stats")
        return res.data
    },
}
